import { TabContextReporter } from '../TabContext';
import Form from 'react-bootstrap/Form';
import { useForceUpdate } from '../util';
export default function MathJax(props) {
  const dataProps = props.data.props;
  const forceUpdate = useForceUpdate();
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    key: 0,
    index: "0",
    title: "Formula Editor"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "MathJax Formula"), ": ", /*#__PURE__*/React.createElement("i", null, "The formula to be rendered with MathJax")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.text,
    onChange: e => {
      dataProps.text = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }))));
}